import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";
import { getFileType } from "utils/file";

const DocumentPreviewModal = ({ isOpen, toggle, file }) => {
  const [zoom, setZoom] = useState(1);

  if (!file) return null;

  const type = getFileType(file.file_name);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" fullscreen>
      <ModalHeader toggle={toggle}>
        {file.file_name}
      </ModalHeader>

      <ModalBody className="text-center bg-light">
        {type === "image" && (
          <div style={{ overflow: "auto" }}>
            <img
              src={file.url}
              alt={file.file_name}
              style={{
                transform: `scale(${zoom})`,
                transition: "transform .2s",
                maxWidth: "100%"
              }}
            />
          </div>
        )}

        {type === "pdf" && (
          <iframe
            src={file.url}
            title={file.file_name}
            width="100%"
            height="600"
            style={{ border: "none" }}
          />
        )}

        {type === "other" && (
          <p className="text-muted">Aperçu non disponible</p>
        )}
      </ModalBody>

      <ModalFooter className="justify-content-between">
        <div className="d-flex gap-2">
          {type === "image" && (
            <>
              <Button size="sm" onClick={() => setZoom(z => z + 0.1)}>+</Button>
              <Button size="sm" onClick={() => setZoom(z => Math.max(1, z - 0.1))}>−</Button>
            </>
          )}
        </div>

        <Button color="secondary" onClick={toggle}>
          Fermer
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DocumentPreviewModal;
